/* Hamburgster: Sticky Cart Hide When Empty - Horizon */
(function() {
  function checkCartQuantity(stickyCart, quantityElement) {
    if (!stickyCart || !quantityElement) return;
    var quantity = parseInt(quantityElement.textContent || quantityElement.innerText || '0', 10);
    stickyCart.style.display = quantity === 0 ? 'none' : 'block';
  }

  function setupStickyCart() {
    var stickyCart = document.getElementById('xboost-upsell-sticky-cart-root');
    var quantityElement = document.querySelector('.xb_sticky_cart_quantity');
    if (stickyCart && quantityElement) {
      checkCartQuantity(stickyCart, quantityElement);
      var obs = new MutationObserver(function() {
        checkCartQuantity(stickyCart, quantityElement);
      });
      obs.observe(quantityElement, { childList: true, subtree: true, characterData: true });
      return true;
    }
    return false;
  }

  function init() {
    if (!setupStickyCart()) {
      var retries = 0;
      var interval = setInterval(function() {
        retries++;
        if (setupStickyCart() || retries > 20) clearInterval(interval);
      }, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();